export default __webpack_public_path__ + "static/media/gallery_02.2a51f2cb.jpg";